export const STATUS_OPTIONS = [
  {
    label: "All",
    value: null,
  },
  {
    label: "Wait confirm",
    value: "WAIT_CONFIRM",
  },
  {
    label: "Success",
    value: "SUCCESS",
  },
  {
    label: "Transfer NFT fail",
    value: "TRANSFER_NFT_FAIL",
  },
  {
    label: "Fail",
    value: "FAIL",
  },
];

export const TYPE_OPTIONS = [
  {
    label: "All",
    value: null,
  },
  {
    label: "Point bonus",
    value: "POINT_BONUS",
  },
  {
    label: "Rebate rate",
    value: "REBATE_RATE",
  },
  {
    label: "NFT reward",
    value: "NFT_REWARD",
  },
];
